import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
      },
    },
    leftSection: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      gap: '12px',
      [theme.breakpoints.down('sm')]: { gap: '10px' },
    },
    backButton: {
      height: '32px',
      width: '32px',
      padding: '4px',
      borderRadius: '4px',
      // border: '1px solid rgba(233, 235, 245, 1)',
      // background: 'rgba(250, 250, 254, 1)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        height: '28px',
        width: '28px',
        padding: '3px',
      },
    },
    title: {
      fontSize: '22px',
      fontWeight: 500,
      color: 'rgba(27, 42, 71, 1)',
      lineHeight: '20px',
      fontStyle: 'normal',
      [theme.breakpoints.down('md')]: { fontSize: '22px' },
      [theme.breakpoints.down('sm')]: { fontSize: '20px' },
    },
    customChip: {
      borderRadius: '100px',
      color: '#1976D2',
      border: '1px solid #1976D2',
      // backgroundColor: '#FFE4E3',
      // border: '1px solid rgba(46, 125, 50, 1)',
    },
  
    /* Tabs */
    tabsRow: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      borderBottom: '1px solid rgba(198, 199, 209, 1)',
      gap: '15px',
      [theme.breakpoints.down('sm')]: { gap: '12px' },
    },
    tab: {
      display: 'flex',
      gap: '12px',
      padding: '6px',
      cursor: 'pointer',
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        gap: '10px',
        padding: '5px',
      },
    },
    tabActiveBorder: {
      borderBottom: '1px solid rgba(63, 81, 181, 1)',
      marginBottom: '-1px',
    },
    tabInactiveBorder: {
      borderBottom: '1px solid transparent',
      marginBottom: 0,
    },
    tabImage: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon16: {
      height: 16,
      width: 16,
    },
    tabText: {
      fontSize: '14px',
      fontWeight: 400,
      fontStyle: 'normal',
      [theme.breakpoints.down('sm')]: { fontSize: '13px' },
    },
    tabTextActive: {
      color: 'rgba(63, 81, 181, 1)',
    },
    tabTextInactive: {
      color: 'rgba(120, 121, 142, 1)',
    },
  }));

export default useStyles;